'use strict';

var AlarmDialogView = require('components/devices/views/alarm/alarm_dialog_view');
var AlarmListView = require('components/devices/views/alarm/alarm_list_view');
var App = require('app');
var AppState = require('app_state');
var CommonViews = require('components/common/views');
var DeviceSelection = require('utils/device_selection');
var HomeController = require('components/home/home_controller');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

var AlarmController = Marionette.Object.extend({
    showAlarmList: function (data, isRefresh, breadcrumbsView, triggerSidebar, ownerID, ownerDevice) {
        var self = this;
        HomeController.showBaseLayout({
            cb: function () {
                if (!isRefresh) {
                    self.doTriggerSidebar(triggerSidebar);
                }

                if (data === undefined) {
                    self.showError();
                    return;
                }
                self.addOwnerData(data, ownerID, ownerDevice);
                self.view = new AlarmListView({
                    controller: self,
                    collection: data,
                    ownerID: ownerID,
                    ownerDevice: ownerDevice,
                });

                if (data && data.models.length > 0) {
                    App.showContentView(self.view);
                } else {
                    self.view = undefined;
                    var contentView = new CommonViews.Message({
                        title: I18N.TR('Keine Alarmeinstellungen vorhanden'),
                        text: ownerID
                            ? I18N.TR('Momentan ist kein Alarm für das Gerät konfiguriert.')
                            : I18N.TR('Momentan ist kein Alarm konfiguriert.'),
                        action_label: I18N.TR('Alarm hinzufügen'),
                        action_cb: function () {
                            self.showDialogByOwner(ownerID, ownerDevice);
                        },
                    });
                    App.showContentView(contentView);
                }
                if (breadcrumbsView) {
                    AppState.layout.showChildView('breadcrumbs', breadcrumbsView);
                }
            },
        });
    },

    showError: function () {
        var contentView = new CommonViews.Message({
            title: I18N.TR('Fehler'),
            text: I18N.TR('Die Alarme konnten nicht geladen werden.'),
            color_class: 'box-color-error',
        });

        App.showContentView(contentView);
        return;
    },

    show: function (id, ownerID, breadcrumbsView, triggerSidebar, ownerDevice, isRefresh) {
        var self = this;
        if (id) {
            this.showDialog(id);
        } else {
            var reqAlarmList = App.request('alarm:list', ownerID);
            $.when(reqAlarmList).done(function (data) {
                self.showAlarmList(data, isRefresh, breadcrumbsView, triggerSidebar, ownerID, ownerDevice);
            });
        }
    },

    addOwnerData: function (list, ownerID, ownerDevice) {
        var self = this;
        if (!list) return;

        _.each(list.models, function (m) {
            m.set('ownerID', ownerID);
        });
    },

    doTriggerSidebar: function (triggerSidebar) {
        if (triggerSidebar) triggerSidebar.tab = 'alarm-configuration';
        else triggerSidebar = { req: 'sidebar:default', selected: 'alarm-configuration' };
        App.trigger(
            triggerSidebar.req,
            triggerSidebar.selected,
            triggerSidebar.permissions,
            triggerSidebar.tab,
            triggerSidebar.circuitNames
        );
    },

    refreshContent: function () {
        this.collection.fetch({
            success: function () {},
        });
    },

    createAlarmForDevices: function (devices) {
        var self = this;
        var selection = new DeviceSelection({
            filter: {
                devices: Misc.selectWhere(devices, undefined, function (x) {
                    return x.id;
                }),
            },
        });
        selection.saveChanges({});
        selection.done(function () {
            var filter = {
                selection: selection.selectionID,
                category: Misc.selectWhere(
                    devices,
                    undefined,
                    function (x) {
                        return x.get('category');
                    },
                    true
                ),
            };

            self.showDialog(undefined, undefined, undefined, undefined, filter, true);
        });
    },

    showDialog: function (id, ownerID, ownerDevice, triggerSidebar, filter, noRedirect) {
        var self = this;
        var model = App.request('alarm:get', id);
        var user = App.request('user:me');
        var mails = App.request('company:mailboxes');
        var deviceConfig = ownerID ? App.request('device:values', parseInt(ownerID)) : undefined;

        AppState.requireColumns(function () {
            $.when(model, user, mails, deviceConfig).done(function (model, user, mails, deviceConfig) {
                if (model && ownerID && !id) {
                    model.set('ownerDeviceID', ownerID);
                    model.set('ownerDevice', ownerDevice);
                    // create a fake filter with a category
                    model.set('filter', { category: [ownerDevice.get('category')] });
                }
                model.set('deviceConfig', deviceConfig);

                if (model && filter) {
                    model.set('filter', filter);
                }

                if (!model) {
                    Notification.error(I18N.TR('Die Alarmeinstellung konnte nicht eingespielt werden.'));
                    return;
                }

                var av = new AlarmDialogView({
                    controller: self,
                    model: model,
                    user: user,
                    mailboxes: mails,
                    cb: function (alarm) {
                        App.hideModal();
                        if (!noRedirect) {
                            self.show(undefined, ownerID, undefined, triggerSidebar, ownerDevice, true);
                        }
                    },
                });
                App.showModal(av);
            });
        });
    },

    showDialogByOwner: function (ownerID, ownerDevice) {
        if (ownerID != undefined) {
            this.showDialog(undefined, ownerID, ownerDevice);
        } else {
            this.showDialog();
        }
    },

    delete: function (collection) {
        var list = _.map(_.pairs(collection.selected), function (item) {
            return item[1].id;
        });
        if (list.length == 0) {
            return;
        }

        var msgTail = list.length > 1 ? list.length + ' ' + I18N.TR('Alarme löschen?') : I18N.TR('den Alarm löschen?');

        $.when(App.request('alarm:update:check', list)).done(function (count) {
            if (count === undefined) {
                Notification.show(
                    'error',
                    I18N.TR('Fehler'),
                    I18N.TR('Anzahl erkannter Alarme konnte nicht geprüft werden.')
                );
                return;
            }

            if (count != 0) {
                // active alarms found -> show extended confirmation dialog
                msgTail +=
                    '<br><br>' +
                    I18N.TR('Einige der ausgewählten Alarme sind aktuell aktiv') +
                    ': <strong>' +
                    count +
                    ' ' +
                    (count == 1 ? I18N.TR('Alarm') : I18N.TR('Alarme')) +
                    '</strong>.<br>' +
                    I18N.TR('Diese Alarme werden abgebrochen.');
            }

            var self = this;
            Utils.showConfirmationDialog({
                title: I18N.TR('Alarme löschen'),
                hint: I18N.TR('Wollen Sie wirklich') + ' ' + msgTail,
                action_label: I18N.TR('Löschen'),

                action_cb: function () {
                    var modelsToDelete = _.values(collection.selected);
                    var deleteDefer = $.Deferred();
                    var promise = deleteDefer.promise();

                    App.request(
                        'alarm:delete',
                        _.map(_.pairs(modelsToDelete), function (item) {
                            return item[1];
                        }),
                        deleteDefer
                    );
                    $.when(promise).done(function (success) {
                        if (!success) {
                            Notification.show(
                                'error',
                                I18N.TR('Fehler'),
                                I18N.TR('Alarm konnte nicht gelöscht werden.')
                            );
                            return;
                        }
                        // reload current route
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    });
                },
            });
        });
    },

    setActive: function (list, isActive, callback) {
        var self = this;
        list = _.map(_.pairs(list), function (item) {
            return item[1].id;
        });

        var updateAlarms = function () {
            var req = App.request('alarm:update', list, { is_active: isActive });
            $.when(req).done(function (result) {
                if (callback) callback();
            });
        };

        $.when(App.request('alarm:update:check', !isActive ? list : undefined)).done(function (count) {
            if (count === undefined) {
                Notification.show(
                    'error',
                    I18N.TR('Fehler'),
                    I18N.TR('Anzahl erkannter Alarme konnte nicht geprüft werden.')
                );
                return;
            }

            if (count == 0 || isActive) {
                updateAlarms();
                return;
            }

            Utils.showConfirmationDialog({
                title: I18N.TR('Alarme deaktivieren?'),
                hint:
                    I18N.TR('Einige der ausgewählten Alarme sind aktuell aktiv') +
                    ': <strong>' +
                    count +
                    ' ' +
                    (count == 1 ? I18N.TR('Alarm') : I18N.TR('Alarme')) +
                    '</strong>.<br>' +
                    I18N.TR('Diese Alarme werden abgebrochen.'),
                action_label: I18N.TR('Deaktivieren'),
                action_cb: function () {
                    updateAlarms();
                },
            });
        });
    },
});

module.exports = AlarmController;
